import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { GoalHeroStripes } from "@/apps/goals/components/GoalHeroStripes/GoalHeroStripes";
import Typography from "@/ui/Typography/Typography";
import { useStartupParamsStore } from "@/store/startupParams";
import cls from "./styles.module.scss";

export const GoalsLoader = () => {
  const { t } = useTranslation();
  const serviceType = useStartupParamsStore((state) => state.serviceType);

  const LOADER_TIP_KEYS = [
    "goals.loader.tip1",
    "goals.loader.tip2",
    serviceType === "eats" ? "goals.loader.tip3:eats" : "goals.loader.tip3",
    "goals.loader.tip4",
    "goals.loader.tip5",
  ] as const;

  const [tipKey] = useState(
    () => LOADER_TIP_KEYS[Math.floor(Math.random() * LOADER_TIP_KEYS.length)]
  );

  return (
    <div className={cls.wrapper}>
      <div className={cls.content}>
        <div className={cls.hero}>
          <GoalHeroStripes />
          <img className={cls.targetIcon} src="/goals/target.png" alt="" />
        </div>
        <Typography size="3xl" weight="semibold">
          {t("goals.loader.title")}
        </Typography>
        <div className={cls.loadingTrack}>
          <div className={cls.loadingBar} />
        </div>
        <p className={cls.tip}>{t(tipKey)}</p>
      </div>
    </div>
  );
};
